export default __webpack_public_path__ + "static/media/pink-top-pattern.d3e53f2c.svg";